import { useQuery } from '@tanstack/react-query';
import { supabase } from '../services/supabase';

export interface UserProfile {
  id: string;
  full_name: string;
  avatar?: string;
  roles?: string[] | null;
}

export const useCurrentUserProfile = (userId?: string) => {
  return useQuery<UserProfile | null>({
    queryKey: ['current-user-profile', userId],
    enabled: !!userId,
    queryFn: async () => {
      if (!userId) return null;

      const { data, error } = await supabase
        .from('users')
        .select('id, full_name, avatar, roles')
        .eq('id', userId)
        .single();

      if (error) throw error;
      return data as UserProfile;
    },
    staleTime: 5 * 60_000, // 5 minutes
  });
};
